var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDeleteTrashWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "22px",
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Conversation-Media",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup---add-private-album---view-shared-images",
    transform: "translate(-808.000000, -942.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(68.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(322.000000, 952.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(401.000000, 0.171875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interaction-field",
    transform: "translate(17.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bin",
    transform: "translate(0.172365, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2027275,4.61915926 L15.5705709,19.7478155 C15.5505043,20.2280471 15.134387,20.6249916 14.6509884,20.6249916 L3.61966691,20.6249916 C3.13621837,20.6249916 2.72011434,20.227169 2.70008435,19.7478155 L2.06792778,4.61915926 C2.05603879,4.33463429 1.8150907,4.1135918 1.52975515,4.12544701 C1.24441957,4.13730223 1.02274733,4.37756581 1.03463632,4.66209074 L1.66679289,19.790747 C1.70990754,20.8225584 2.581892,21.65625 3.61966691,21.65625 L14.6509884,21.65625 C15.6882035,21.65625 16.5606898,20.8239463 16.6038624,19.790747 L17.236019,4.66209074 C17.2479079,4.37756581 17.0262357,4.13730223 16.7409001,4.12544701 C16.4555646,4.1135918 16.2146165,4.33463429 16.2027275,4.61915926 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79059829,6.703125 L8.79059829,18.390625 C8.79059829,18.6753968 9.02210918,18.90625 9.30769231,18.90625 C9.59327544,18.90625 9.82478632,18.6753968 9.82478632,18.390625 L9.82478632,6.703125 C9.82478632,6.41835318 9.59327544,6.1875 9.30769231,6.1875 C9.02210918,6.1875 8.79059829,6.41835318 8.79059829,6.703125 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82643435,6.71828389 L5.17116369,18.4057839 C5.17955954,18.6904326 5.41777655,18.9143991 5.70323627,18.9060271 C5.98869595,18.8976551 6.21330057,18.6601149 6.20490468,18.3754661 L5.86017534,6.68796611 C5.85177949,6.40331739 5.61356248,6.17935086 5.32810276,6.18772289 C5.04264308,6.19609488 4.81803847,6.43363514 4.82643435,6.71828389 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4104799,6.68796611 L12.0657506,18.3754661 C12.0573547,18.6601149 12.2819593,18.8976551 12.567419,18.9060271 C12.8528787,18.9143991 13.0910957,18.6904326 13.0994916,18.4057839 L13.4442209,6.71828389 C13.4526168,6.43363514 13.2280122,6.19609488 12.9425525,6.18772289 C12.6570928,6.17935086 12.4188758,6.40331739 12.4104799,6.68796611 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.517094017,2.921875 L17.7535613,2.921875 C18.0391444,2.921875 18.2706553,2.69102182 18.2706553,2.40625 C18.2706553,2.12147818 18.0391444,1.890625 17.7535613,1.890625 L0.517094017,1.890625 C0.231510886,1.890625 0,2.12147818 0,2.40625 C0,2.69102182 0.231510886,2.921875 0.517094017,2.921875 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16814392,2.42587331 L6.53709429,1.50611777 C6.63531585,1.26126151 6.97607871,1.03125 7.23931624,1.03125 L11.031339,1.03125 C11.2964657,1.03125 11.6346582,1.25956335 11.733561,1.50611777 L12.1025114,2.42587331 L13.0627308,2.04287669 L12.6937804,1.12312114 C12.4378213,0.485041219 11.7193469,0 11.031339,0 L7.23931624,0 C6.55322811,0 5.83216411,0.486711019 5.57687483,1.12312114 L5.20792446,2.04287669 L6.16814392,2.42587331 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteTrashWhite);
export default __webpack_public_path__ + "static/media/icDeleteTrashWhite.054c661d957574c8d8daaa85fe35bf47.svg";
export { ForwardRef as ReactComponent };